import React, { FC, useEffect } from 'react';
import { RouteProps } from 'react-router-dom';
import { Sentry } from 'service/Sentry';
import { TemplatePage } from '../TemplatePage/TemplatePage';


interface PageProps extends RouteProps {
  title?: string;
}

export const Page: FC<PageProps> = props => {
  useEffect(() => {
    const prefixo = props.title ? `${props.title} - ` : '';
    
    document.title = `${prefixo}Sistema de Serviço`;
  });

  const { title, ...rest } = props;
  
  const SentryRoute = Sentry.instance.SentryRoute;
  return <TemplatePage>
    <SentryRoute {...rest} />
  </TemplatePage>
};
